import revive_payload_client_4sVQNw7RlN from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/opt/atlassian/pipelines/agent/build/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/opt/atlassian/pipelines/agent/build/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_UYiXMU8ZyN from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt-gtag/dist/runtime/plugin.client.js";
import switch_locale_path_ssr_5csfIgkrBP from "/opt/atlassian/pipelines/agent/build/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/opt/atlassian/pipelines/agent/build/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import templates_pwa_client_4570b8a0_g9JQJYYu0E from "/opt/atlassian/pipelines/agent/build/.nuxt/templates.pwa.client.4570b8a0.ts";
import plugin_ghbUAjaD3n from "/opt/atlassian/pipelines/agent/build/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import plugin_AOuQ1DYzjk from "/opt/atlassian/pipelines/agent/build/node_modules/@sidebase/nuxt-auth/dist/runtime/plugin.mjs";
import plugin_AUP22rrBAc from "/opt/atlassian/pipelines/agent/build/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.js";
import _00_debug_CzQoA0myfc from "/opt/atlassian/pipelines/agent/build/plugins/00.debug.ts";
import _01_resize_observer_client_bORNNEGTws from "/opt/atlassian/pipelines/agent/build/plugins/01.resize_observer.client.ts";
import _02_vuetify_rwZ6VQqJQJ from "/opt/atlassian/pipelines/agent/build/plugins/02.vuetify.ts";
import _03_toastification_TRcESN6V9o from "/opt/atlassian/pipelines/agent/build/plugins/03.toastification.ts";
import _04_publicEvent_GPsUUiLu3C from "/opt/atlassian/pipelines/agent/build/plugins/04.publicEvent.ts";
import _05_sentry_client_aLToQO08jh from "/opt/atlassian/pipelines/agent/build/plugins/05.sentry.client.ts";
import qrcode_client_k7ZrmM9P2F from "/opt/atlassian/pipelines/agent/build/plugins/qrcode.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_UYiXMU8ZyN,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  templates_pwa_client_4570b8a0_g9JQJYYu0E,
  plugin_ghbUAjaD3n,
  plugin_AOuQ1DYzjk,
  plugin_AUP22rrBAc,
  _00_debug_CzQoA0myfc,
  _01_resize_observer_client_bORNNEGTws,
  _02_vuetify_rwZ6VQqJQJ,
  _03_toastification_TRcESN6V9o,
  _04_publicEvent_GPsUUiLu3C,
  _05_sentry_client_aLToQO08jh,
  qrcode_client_k7ZrmM9P2F
]